import PropTypes from "prop-types";
import React from "react";

const TestimonialOneSingle = ({ data, sliderClass }) => {
  return (
    <div
      className={`single-testimonial text-center ${
        sliderClass ? sliderClass : ""
      }`}
    >
      <p>{data.content}</p>
    </div>
  );
};

TestimonialOneSingle.propTypes = {
  data: PropTypes.object,
  sliderClass: PropTypes.string
};

export default TestimonialOneSingle;